import { render, staticRenderFns } from "./ApotIncidents.vue?vue&type=template&id=37982b59&"
import script from "./ApotIncidents.vue?vue&type=script&lang=js&"
export * from "./ApotIncidents.vue?vue&type=script&lang=js&"
import style0 from "./ApotIncidents.vue?vue&type=style&index=0&id=37982b59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports